import { CHANGELOG } from '../data/changelog.js';
import { audio } from '../systems/audio/AudioSystem.js';

/** Read-only scrollable changelog (data/changelog.js), newest entry first. */
export class VersionHistoryMenu {
  constructor(root, { onBack }) {
    this.root = root;
    this.onBack = onBack;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay';
    this._render();
    this.root.appendChild(this.el);
  }

  _render() {
    this.el.innerHTML = '';

    const title = document.createElement('div');
    title.className = 'menu-title';
    title.textContent = 'VERSION HISTORY';
    this.el.appendChild(title);

    const list = document.createElement('div');
    list.className = 'changelog-list';
    for (const entry of CHANGELOG) {
      list.appendChild(this._buildEntry(entry));
    }
    this.el.appendChild(list);

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); this.onBack(); });
    this.el.appendChild(back);
  }

  _buildEntry(entry) {
    const item = document.createElement('div');
    item.className = 'changelog-entry';

    const title = document.createElement('div');
    title.className = 'changelog-entry-title';
    title.textContent = entry.title;
    item.appendChild(title);

    const notes = document.createElement('ul');
    notes.className = 'changelog-entry-notes';
    for (const note of entry.notes) {
      const li = document.createElement('li');
      li.textContent = note;
      notes.appendChild(li);
    }
    item.appendChild(notes);

    return item;
  }

  destroy() {
    this.el.remove();
  }
}
